import React, { useMemo } from "react";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TSUtils from "../../../../../utils/helpers/TSUtils";
import {
  KC_Text_Sizes,
  KC_Weights
} from "../../../../../designsystem/ds_commons";
import KC_UIText from "../../../../../designsystem/typography/KC_UIText/KC_UIText";
import KC_Text from "../../../../../designsystem/typography/KC_Text/KC_Text";
import KC_PrizeIcon from "../../../../../designsystem/KC_PrizeIcon/KC_PrizeIcon";
import { MonthlyLottery } from "kadow-model-monthly-lottery";
import { LANGUAGE } from "../../../../../utils/i18n/i18n";

interface GLMCardProps {
  glm: MonthlyLottery;
  isUpsell?: boolean;
}

const GLMCard: React.FC<GLMCardProps> = (props) => {
  const isUpsell = props.isUpsell === undefined ? false : props.isUpsell;

  const clsName = useMemo(() => {
    return isUpsell ? "glm-card-upsell" : "glm-card";
  }, [isUpsell]);

  const dateText = useMemo(() => {
    if (
      props.glm.minTs &&
      props.glm.maxTs &&
      props.glm.minTs > 0 &&
      props.glm.maxTs > 0
    ) {
      return TSUtils.formatDateRange(props.glm.minTs, props.glm.maxTs);
    }
    return TSUtils.getGLMPeriod(props.glm);
  }, [props.glm]);

  return (
    <div
      className={`d-flex flex-column align-items-center ${clsName} flex-grow-1 gap-md py-2`}
    >
      {!!props.glm.img ? (
        <img
          src={`https://tootsweet.twic.pics/cdm/kadow/glm/${props.glm.img}`}
          style={{ width: "50%" }}
        />
      ) : (
        <KC_PrizeIcon emoji={props.glm.e ?? "🚀"} />
      )}
      <div className="d-flex flex-column gap-sm align-items-center flex-grow-1 p-2">
        <KC_Text
          size={KC_Text_Sizes.lg}
          weight={KC_Weights.bold}
          text={props.glm.prizeL?.[LANGUAGE] || props.glm.prize}
          className="text-center"
        />
        <div className="d-flex align-items-center mt-auto">
          <span className="text-blue p-1">
            <FontAwesomeIcon icon={faCalendar} />
          </span>
          <KC_UIText
            weight={KC_Weights.reg}
            text={dateText}
            className="text-blue text-capitalize "
          />
        </div>
      </div>
    </div>
  );
};

export default GLMCard;
